var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labeled-flex-section"},[_c('div',{staticClass:"section-label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_c('div',{staticClass:"section-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }